export const isValidUrl = (url: string | URL) => {
  try {
    const parsed = url instanceof URL ? url : new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};
